import LoaderIcon from '../../assets/images/spinner.png';

interface LoaderProps {
  visible?: boolean;
  className?: string;
}

const Loader = ({ visible = false, className }: LoaderProps) => {
  return (
    visible && (
      <div className={`fixed top-0 left-0 flex items-center justify-center z-52 w-full h-full ${className}`}>
        <div className="absolute top-0 left-0 w-full h-full bg-white opacity-80"></div>
        <img src={LoaderIcon} className="spin w-[113px] h-[113px] animate-[spin_2s_linear_infinite]" />
      </div>
    )
  );
};

export default Loader;
